import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import { LuTrash2 } from "react-icons/lu";
import RoleModal from "./RoleModal";
import { CiUndo, CiWarning } from "react-icons/ci";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const roles = [
    // { value: "owner", label: "Owner" },
    { value: "manager", label: "Manager" },
    { value: "developer", label: "Developer" },
    { value: "member", label: "Member" }
];

const UpdateMemberModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    selectedMember,
    userData,
    orgData,
    fetchOrgData
}) => {
    const {t} = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [openRoleModal, setOpenRoleModal] = useState(false);

    const [formData, setFormData] = useState({
        orgRoles: [],
        deleted_orgs: []
    });

    useEffect(() => {
        if (selectedMember) {
            setFormData({
                orgRoles: selectedMember.organizations?.map(org => ({
                    orgId: org.id,
                    role: org.role,
                    deleted: false
                })) || [],
                deleted_orgs: []
            });
        }
    }, [selectedMember]);

    const handleOrgRoleChange = (orgId, newRole) => {
        setFormData(prev => ({
            ...prev,
            orgRoles: prev.orgRoles.map(or =>
                or.orgId === orgId ? { ...or, role: newRole } : or
            )
        }));
    };

    const handleDeleteOrg = (orgId) => {
        setFormData(prev => ({
            orgRoles: prev.orgRoles.map(or =>
                or.orgId === orgId ? { ...or, deleted: true } : or
            ),
            deleted_orgs: [...prev.deleted_orgs, orgId]
        }));
    };

    const handleUndoDeleteOrg = (orgId) => {
        setFormData(prev => ({
            orgRoles: prev.orgRoles.map(or =>
                or.orgId === orgId ? { ...or, deleted: false } : or
            ),
            deleted_orgs: prev.deleted_orgs.filter(id => id !== orgId)
        }));
    };

    const handleSave = async () => {
        if (formData.orgRoles.some(or => !or.role && !or.deleted)) {
            setErrorMessage({ message: t.members.all_org_role, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/update_member`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    member_id: selectedMember.id,
                    orgRoles: formData.orgRoles,
                    deleted_orgs: formData.deleted_orgs
                }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "Something went wrong");

            if (fetchRecords) await fetchRecords();
            closeModal();
        } catch (error) {
            setErrorMessage({ message: error.message || "Server error", display: true });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setFormData({
            orgRoles: selectedMember?.organizations?.map(org => ({
                orgId: org.id,
                role: org.role,
                deleted: false
            })) || [],
            deleted_orgs: []
        });
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    useEffect(() => {
        if (show) {
            fetchOrgData()
        }
    }, [show])

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.members.update_title}</p>
            </div>

            <div className="modal_main_cont">
                {orgData.length > 0 ? (
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">{t.members.org_roles}</label>
                            <div className="org_role_cont">
                                {formData.orgRoles.map(({ orgId, role, deleted }) => {
                                    const currentUserOrg = orgData?.find(o => o.id === orgId);
                                    const hasPermission =
                                        currentUserOrg &&
                                        (currentUserOrg.role === "manager" || currentUserOrg.role === "owner");

                                    const org = selectedMember.organizations.find(o => o.id === orgId);
                                    if (!org) return null;

                                    return (
                                        <div key={orgId} className={`org_role_row ${deleted ? "org_role_row_deleted" : ""}`}>
                                            <div className="label_input">
                                                <p className="org_name">
                                                    {org.name}{" "}
                                                    {!deleted && hasPermission && !org.creator && (
                                                        <button
                                                            onClick={() => handleDeleteOrg(orgId)}
                                                            className="org_delete_btn"
                                                        >
                                                            <LuTrash2 />
                                                        </button>
                                                    )}

                                                    {deleted && (
                                                        <button
                                                            onClick={() => handleUndoDeleteOrg(orgId)}
                                                            className="org_undo_btn"
                                                        >
                                                            <CiUndo />
                                                        </button>
                                                    )}
                                                </p>
                                            </div>
                                            {!deleted && !org.creator && hasPermission && (
                                                <Dropdown>
                                                    <Dropdown.Toggle as="div" className="register_form_first fade-in">
                                                        {role.charAt(0).toUpperCase() + role.slice(1)}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="custom_dropdown_menu">
                                                        <div className="dropdown_container fade-in">
                                                            {roles.map(r => (
                                                                <Dropdown.Item
                                                                    key={r.value}
                                                                    onClick={() => handleOrgRoleChange(orgId, r.value)}
                                                                    className="settings_link"
                                                                >
                                                                    {r.label}
                                                                </Dropdown.Item>
                                                            ))}
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}

                                            {!deleted && !hasPermission && !org.creator && (
                                                <div className="role_warning_text warning_deleted_member" dangerouslySetInnerHTML={{__html:t.members.warning_permissions}}></div>
                                            )}

                                            {!deleted && org.creator && (
                                                <div className="role_warning_text warning_deleted_member" dangerouslySetInnerHTML={{__html:t.members.warning_creator}}>
                                                </div>
                                            )}

                                            {deleted && (
                                                <div className="role_warning_text warning_deleted_member" dangerouslySetInnerHTML={{__html:t.members.warning_remove}}>
                                                    
                                                </div>
                                            )}

                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="modal_header_title_description"></p>
                )}
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>

            <RoleModal
                show={openRoleModal}
                handleClose={() => setOpenRoleModal(false)}
            />
        </Modal>
    );
};

export default UpdateMemberModal;